import HeroSection from './components/HeroSection'
import styled from "styled-components";
import img1 from './components/logo2.png'
// import { useProductContext } from './context/productContext'


const About = () => {
  // const {myName} = useProductContext();
  const data={
    name: "Ansh ecom"
  }
  return (
    <Wrapper>
     {/* {myName} */}
      <HeroSection myData={data} />

      <div className="container">
    <div className="row about1 p-4 justify-content-evenly">
        <div className="col-md-5 c1"></div>
        <div className="col-md-5 c2 p-5">
            <p>OUR STORY</p>
            <h2>About Our Store</h2><br/>
            <p >Open created shall two he second moving whose. He face whose two upon, fowl behold waters. Fly there their day creepeth. Darkness beginning spirit after. Creepeth subdue. Brought may, first. Under living that.</p><br/>
            <p>
                Third. For morning whales saw were had seed can’t divide it light shall moveth, us blessed given wherein.</p>
        </div>

    </div>
    </div>


      
    </Wrapper>
  
  )
}

const Wrapper = styled.section`
.about1 .c1 {
  height: 450px;
  background: url(${img1});
  background-size: cover;
}
p{
  font-size: 20px;
  color:gray;

}
`

export default About
